import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 213A797A-41C0-4804-A5B1-A841898CCC11
 * name message-alert
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message-alert.svg
 * tags
 * - Alert / Error 
 */
export const MessageAlertIcon = createSvgIcon(<><path d="M13 11H11V5H13M13 15H11V13H13M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z" /></>, 'MessageAlertIcon');
export default MessageAlertIcon